import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Grid } from '@mui/material';
import { CopyIcon, Warning, RoundedQuestion } from "../../assets/images/icons";
import Notice from '../main/Notice';
import { getText, sendFormData } from '../../libs/utils';
import TimerTile from './TimerTile';


const PayByMerchant = ({ order, handleTimeOut }) => {

  useEffect(() => {
    if (window.localStorage.lastRedirect !== order.id) {
      // this.setState({ redirect: true });
      setTimeout(() => {
        showDialog();
      }, 5000);
    }
  }, []);

  const showDialog = () => {
    if (order?.toPaymentSystemType?.value == "BANK") {
      window.showModal({
        header: getText('dialKeepOrderHeader'),
        content: getText('dialKeepOrderText'),
        button: getText('dialKeepOrderButton'),
        onAccept: () => {
          goPay();
        },
      });
    } else {
      goPay();
    }
  }

  const goPay = () => {
    const merchData = order.deposits[0].tabs[0].outputs.find(item => item.type === "form");
    sendFormData(merchData.value.action, merchData.value.inputs, merchData.value.method, merchData.value.target);
    window.localStorage.lastRedirect = order.id;
    // this.setState({ redirect: false });
  }


  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="h3">{getText('payMerchTopHeader')}</Typography>
        <TimerTile timerEnd={order.endAt} handleTimeOut={handleTimeOut} />
      </Box>

      <Typography variant="regularCaption" component="div">
        {getText('payMerchText01')} <Typography variant="link" onClick={() => showDialog()} sx={{ textTransform: 'none', fontSize: '14px' }}>{getText('payMerchText02')}</Typography> {getText('payMerchText03')}
      </Typography>

      {Object.keys(order).length > 0 && order.deposits[0].tabs[0].message && (
        <Notice
          type="warning"
          icon={<Warning />}
          style={{ margin: '21px 0 0px' }}
        >
          <p>{order.deposits[0].tabs[0].message}</p>
        </Notice>
      )}
    </>
  )
}

export default PayByMerchant
